import { ChangeDetectionStrategy, Component, computed, inject, model } from "@angular/core";

import { AngularSvgIconModule } from "angular-svg-icon";

import { AuthService } from "@core/services/auth.service";
import { BaseModalComponent } from "@shared/components/modal/base-modal.component";
import { ModalComponent } from "@shared/components/modal/modal.component";

@Component({
  selector: "component-welcome-modal",
  templateUrl: "./welcome-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalComponent, AngularSvgIconModule]
})
export class WelcomeModalComponent extends BaseModalComponent {
  private readonly _authService = inject(AuthService);
  private readonly _user = computed(() => this._authService.currentUser());

  // Input parameter to determine if this is an invite registration
  protected readonly isInviteRegistration = model<boolean>(false);

  protected readonly organizationName = computed(() => {
    return this._user()?.organization?.name || "";
  });

  protected readonly planName = computed(() => {
    return this._user()?.organization?.plan?.name || "";
  });

  protected readonly expirationMessage = computed(() => {
    const user = this._user();
    const plan = user?.organization?.plan;

    if (plan && plan.expirationPeriod && plan.expirationUnit) {
      const unit = plan.expirationUnit.toLowerCase();
      const singleUnit = unit.endsWith("s") ? unit.slice(0, -1) : unit;
      const displayUnit = plan.expirationPeriod === 1 ? singleUnit : unit;
      return `for ${plan.expirationPeriod} ${displayUnit}`;
    }

    return "for a limited time";
  });
}
